// extracted by mini-css-extract-plugin
module.exports = {"power-preparedness-B":"B_power-preparedness-B___Twbi"};